export enum EDeviceModel {
  VP3701 = 'VP3701',
  LTR24 = 'LTR24',
  LTR51 = 'LTR51',
  GENERATOR = 'GENERATOR',
  LTR_SYNC = 'LTR_SYNC',
  CONTROLLER = 'CONTROLLER'
}
